// import React from "react";
// import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
// import Topbar from "../../components/Super Admin/TopBar/TopbarQuestionnaire";
// import QuestionnaireVersions from "../../components/Super Admin/Questionnaire Management/QuestionnaireVersions";
// // import "../../css/QuestionnairePage.css";

// const QuestionnairePage: React.FC = () => {
//   return (
//     <div className="page-container">
//       {/* <Sidebar /> */}
//       <div className="content">
//         <Topbar />
//         <div style={{ padding: "20px" }}>
//         <h2>Questionnaire Versions Management</h2>
//         <QuestionnaireVersions />
//       </div>
//       </div>
//     </div>
//   );
// };

// export default QuestionnairePage;




import React from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import Topbar from "../../components/Super Admin/TopBar/TopbarQuestionnaire";
import QuestionnaireVersions from "../../components/Super Admin/Questionnaire Management/QuestionnaireVersions";
// import "../../css/QuestionnairePage.css";

const QuestionnairePage: React.FC = () => {
  return (
    <>
        <Topbar />
        <div style={{ padding: "20px" }}>
          <h2 style={{color:'#00a8a8'}}>Questionnaire Versions Management</h2>
          
          {/* ✅ FIX: Pass the required props to the component */}
          <QuestionnaireVersions 
            categorySlug="health" 
            categoryTitle="Health" 
          />
        </div>
    </>
  );
};

export default QuestionnairePage;